{
  "filters": {
    "state": "State",
    "any": "Any",
    "approved": "Approved",
    "rejected": "Rejected",
    "awaitingReview": "Awaiting review",
    "organization": "Organization",
    "clientName": "Client name",
    "requestedDate": "Requested date",
    "approvedDate": "Approved date",
    "daysWaiting": "Days waiting",
    "document": "Document",
    "name": "Name",
    "source": "Source",
    "sourceOptions": {
      "USER": "User",
      "FLINKS": "Flinks"
    },
    "failReason": "Fail reason",
    "transitNumber": "Transit number",
    "institutionNumber": "Institution number",
    "bankAccountNumber": "Bank account number",
    "actions": "Actions",
    "stateOptions": {
      "AWAITING_REVIEW": "Awaiting review",
      "APPROVED": "Approved",
      "REJECTED": "Rejected",
      "ARCHIVED": "Archived"
    }
  },
  "noFile": "No document uploaded!",
  "bankAccountTransitions": {
    "approve": "Approve",
    "reject": "Reject"
  },
  "moderateBankAccount": "Are you sure?",
  "confirmationDialogTitle": "Are you sure you want to {{transition}} this bank account?",
  "bankAccountTitle": "{{name}}'s Bank Account",
  "bankAccountTitleFallback": "Bank Account"
}
